import { render, staticRenderFns } from "./KernelInputMessageInfoView.vue?vue&type=template&id=0c8a5b40&"
import script from "./KernelInputMessageInfoView.vue?vue&type=script&lang=js&"
export * from "./KernelInputMessageInfoView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports